"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemVariables = exports.SystemVariable = exports.SystemVariableKey = void 0;
var SystemVariableKey;
(function (SystemVariableKey) {
    SystemVariableKey["SessionTimeout"] = "SESSION_TIMEOUT";
    SystemVariableKey["SessionExtAlarmTime"] = "SESSION_EXT_ALARM_TIME";
    SystemVariableKey["SessionExtTimeout"] = "SESSION_EXT_TIMEOUT";
    SystemVariableKey["LoginMaxTryCount"] = "LOGIN_MAX_TRY_COUNT";
    SystemVariableKey["LoginFailCheckTerm"] = "LOGIN_FAIL_CHECK_TERM";
    SystemVariableKey["EmailVerifyMaxTryCount"] = "EMAIL_VERIFY_MAX_TRY_COUNT";
})(SystemVariableKey = exports.SystemVariableKey || (exports.SystemVariableKey = {}));
class SystemVariable {
}
exports.SystemVariable = SystemVariable;
class SystemVariables {
}
exports.SystemVariables = SystemVariables;
//# sourceMappingURL=system.js.map